import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'mapToArray', standalone: false })
export class MapToArrayPipe<K, V> implements PipeTransform {
    transform(map: Map<K, V>): V[] {
        return Array.from(map.values());
    }
}